import type { QueryStatus } from '@/types';

/**
 * Combines multiple query statuses into a single status object
 * @param statuses - Array of query status objects to combine
 * @returns Combined status with aggregated isPending, isError and first error encountered
 */
export const combineQueryStatuses = (statuses: (QueryStatus | null)[]): QueryStatus => {
  const validStatuses = statuses.map(
    (status) =>
      status || {
        isPending: false,
        isError: false,
        error: null,
      }
  );
  return {
    isPending: validStatuses.some((status) => status.isPending),
    isError: !validStatuses.some((status) => status.isPending)
      ? validStatuses.some((status) => status.isError)
      : false,
    error: !validStatuses.some((status) => status.isPending)
      ? validStatuses.find((status) => status.error)?.error || null
      : null,
  };
};

export const getEmptyPayoutQuarters = () => ({
  1: { amount: 0, currency: '' },
  2: { amount: 0, currency: '' },
  3: { amount: 0, currency: '' },
  4: { amount: 0, currency: '' },
  year: { amount: 0, currency: '' },
});
